import { render, staticRenderFns } from "./category-info.vue?vue&type=template&id=19812a92&"
import script from "./category-info.vue?vue&type=script&lang=js&"
export * from "./category-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports